import { render } from "./MarkdownMessage.vue?vue&type=template&id=7df68315&ts=true"
import script from "./MarkdownMessage.vue?vue&type=script&lang=ts"
export * from "./MarkdownMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__